import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { DeviceDetectionService } from "../services/device-detection.service";
import { routes } from "../../../environments/environment.routes";

export const nativeScanDeviceGuard = async () => {
  const deviceDetectionService = inject(DeviceDetectionService);
  const router = inject(Router);

  const currentQueryParams =
    router.currentNavigation()?.extractedUrl?.queryParams;

  // UA-CH model detection is async; wait for it so Zebra devices aren't misrouted.
  await deviceDetectionService.waitForDeviceDetection();

  const deviceInfo = deviceDetectionService.deviceInfo();

  // ONLY allow Zebra devices to access native scan
  if (deviceInfo.isZebraDevice) {
    return true;
  }

  // Block all other devices from accessing native scan
  return router.createUrlTree(
    [routes.frontend.scan, routes.frontend.scanCamera],
    {
      queryParams: currentQueryParams,
      queryParamsHandling: "merge",
    },
  );
};
